module.exports = __webpack_public_path__ + "assets/imgs/gmp/gmp-gAnalytics.8390a6241c7dd84ec5a3ec7b91c3ee9d.png";